import React, { useEffect, useState } from 'react';
import {
  getTitleArtwork,
  subscribeTitleArtwork,
  DEFAULT_TITLE_ARTWORK,
} from '../utils/titleArtworkStorage';

export const MainTitleScreenArtwork: React.FC = React.memo(() => {
  const [artworkSrc, setArtworkSrc] = useState<string>(() => getTitleArtwork());

  useEffect(() => {
    const unsubscribe = subscribeTitleArtwork((url) => {
      setArtworkSrc(url || DEFAULT_TITLE_ARTWORK);
    });
    return unsubscribe;
  }, []);

  const handleImageError = () => {
    if (artworkSrc !== DEFAULT_TITLE_ARTWORK) {
      setArtworkSrc(DEFAULT_TITLE_ARTWORK);
    }
  };

  return (
    <div className="relative w-full h-full overflow-hidden select-none bg-black flex items-center justify-center">
      {/* Artwork Écran Titre du Menu Principal */}
      <div className="relative w-full h-full flex items-center justify-center overflow-hidden">
        <img
          src={artworkSrc}
          alt="Artwork Écran Titre"
          loading="eager"
          decoding="async"
          fetchPriority="high"
          onError={handleImageError}
          className="w-full h-full object-cover object-center"
        />
      </div>
    </div>
  );
});
